import React, { useEffect, useState } from "react";
import { Button, PlusIcon, TrashIcon } from "evergreen-ui";
import { Card, Table } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";

var db = getDatabase(Firebase);
const InitiativeProgramLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Initiative Sector',
			dataIndex: 'initiative',
			key: 'initiative',
			sorter: (a, b) => a.initiative && a.initiative.localeCompare(b.initiative),
		},
		{
			title: 'Code',
			dataIndex: 'code',
			key: 'code',
			sorter: (a, b) => a.code && a.code.localeCompare(b.code),
		},
		{
			title: 'Created',
			dataIndex: 'dateCreated',
			key: 'dateCreated',
			sorter: (a, b) => a.dateCreated && a.dateCreated.localeCompare(b.dateCreated),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]

	const [initiativeProgArray, setInitiativeProgArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/initiativeTypes"));


	useEffect(() => {
		var tempArray = [];
		if (arrayIn) {

			arrayIn.map((item, index) => {
				tempArray.push({
					key: index,
					initiative: item.name,
					code: item.code,
					dateCreated: item.dateCreated ? new Date(item.dateCreated).toLocaleDateString() : "unknown",
					id: item.id,
					action: canDelete ? (
						<Button intent="danger" onClick={() => {
							props.messageBack("initiativeTypes", "delete", item.id);

						}}>
							<TrashIcon color="danger" />
						</Button>
					) : null
				})
			});

			setInitiativeProgArray(tempArray);
		}



	}, [arrayIn, props]);

	return (
		<div className="font-Nunito">
			<div>
				{canCreate && (
					<Button appearance="primary" className="ml-3  my-2" onClick={() => { props.messageBack("initiativeTypes", "create") }}>
						New Initiative Sector<PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Initiative Sectors",
						exportButtons: false,
						sheetname: "Initiative Sectors",
					}), initiativeProgArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">

				<div>
					<Table style={{ overflow: "auto" }} id={"dataTable"} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
						dataSource={initiativeProgArray} columns={columns} />
				</div>
			</Card>
		</div>

	);
}
export default InitiativeProgramLayout;
